// extracted by mini-css-extract-plugin
export default {"integrationIconContainer":"IntegrationLinkRow-module__integrationIconContainer--iYynF","animatedBackground":"IntegrationLinkRow-module__animatedBackground--BNrF1"};